import { ComponentPropsWithRef } from 'react';

import CustomIcon from '@components/utils/CustomIcon';
import { PlayCircleIcon } from '@assets/icons';

import { Wrapper } from './styled';

type Props = ComponentPropsWithRef<'button'>;

const PlayVideoBadge = (props: Props) => {
  return (
    <Wrapper {...props}>
      <CustomIcon fontSize={33} icon={PlayCircleIcon} paletteColor='tomato' />
    </Wrapper>
  );
};

export default PlayVideoBadge;
